// Options for Add Rule Dialog
export const ACTION_OPTIONS = [
  { label: "Facility", value: "facility" },
  { label: "Patient", value: "patient" },
  { label: "Provider", value: "provider" },
];

export const CONDITION_OPTIONS = [
  { label: "Equals", value: "equals" },
  { label: "Contains", value: "contains" },
  { label: "Starts with", value: "starts_with" },
  { label: "Ends with", value: "ends_with" },
];

export const PROVIDER_OPTIONS = [
  { label: "Dr. Smith", value: "dr_smith" },
  { label: "Dr. Johnson", value: "dr_johnson" },
  { label: "Dr. Williams", value: "dr_williams" },
  { label: "Dr. Brown", value: "dr_brown" },
];

export const TRIGGER_OPTIONS = [
  { label: "Emergency Contact", value: "emergency_contact" },
  { label: "Unit Leader", value: "unit_leader" },
  { label: "Patient", value: "patient" },
  { label: "Provider", value: "provider" },
  { label: "Facility Admin", value: "facility_admin" },
];

export const CHANNEL_OPTIONS = [
  { label: "Email", value: "email" },
  { label: "SMS", value: "sms" },
];

// Disposition Trigger options for the Add Rule dialog
export const DISPOSITION_OPTIONS = [
  { label: "Transfer Off Property", value: "transferOffProperty" },
  { label: "Transfer to JHC / Base Camp", value: "transferToJHC" },
  { label: "Admit to Observation (Clinic)", value: "transferToClinic" },
  { label: "Discharge", value: "discharged" },
  { label: "Offsite Transfer Despostions", value: "offsiteTransfer" },
  { label: "EMS Sent to Hospital", value: "emsSentToHospital" },
];

// Transport levels shown when the disposition is "Transfer Off Property".
// Backend TransportLevel enum values are the strings themselves.
export const TRANSPORT_LEVEL_OPTIONS = [
  { label: "Basic Life Support", value: "Basic Life Support" },
  { label: "Advance Life Support", value: "Advance Life Support" },
  { label: "Crirtical Care Transport", value: "Crirtical Care Transport" },
  { label: "Other Vehicle", value: "Other Vehicle" },
];

// Form field constants
export const RULE_DATA = {
  RULE_NAME: "ruleName",
  ACTION: "action",
  CONDITION: "condition",
  PROVIDER_NAME: "providerName",
  TRIGGER: "trigger",
  CHANNEL: "channel",
  START_DATE: "startDate",
  END_DATE: "endDate",
};
